import DropdownButtonSplitComponent from './DropdownButtonSplit.component';

export * from './DropdownButtonSplit.component';
export default DropdownButtonSplitComponent;
